import styled from 'styled-components'

export const Container = styled.div`
  text-align: center;
  width: 32%;
  margin-top: 12rem;
`

export const Text = styled.p `
  font-size: 1.5rem;
  font-weight: 600;
`